import Helper from '@ember/component/helper';
import { isNone } from '@ember/utils';
import TimeZones from 'cio/utils/time-zones';

export function timeZone([value]) {
  let zone = TimeZones.find((tz) => tz.matchingValues.includes(value));

  if (isNone(zone)) {
    return `unknown (${value})`;
  }

  return zone.name;
}

export default Helper.helper(timeZone);
